import { SchoolAnswer, Step } from '../components'
import type { InputQuestionValues } from '../typings'
import type { StepProps } from './StepProps'

const EDUCATOR_SCHOOL: InputQuestionValues = {
  key: 'educator_school',
  trackingKey: 'school',
  question: `What's your school's name?`
}

export const EducatorStep = (props: StepProps) => {
  return (
    <Step
      index={props.index}
      surveyKey={EDUCATOR_SCHOOL.key}
      trackingKey={EDUCATOR_SCHOOL.trackingKey}
      title={EDUCATOR_SCHOOL.question}
    >
      <SchoolAnswer
        surveyKey={EDUCATOR_SCHOOL.key}
        question={EDUCATOR_SCHOOL.question}
        text='School Name'
      />
    </Step>
  )
}
